module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAA1ElEQVR4Xu2asQ2DQAAD7dGoQKQl0zEDPYvRRRh9iig7+NiAwz7z0lvlj8vfXwAgAeUEqEB5AJAgFaAC5QR8Xddhe0lSVQfbSXIOALdUK8MMAGluAQBIABXAAUiQFSgmwAwyg8xg+QxO8/4pdqA8zXv3fwAASAAVwAGsQDEBZpAZZAaZwfoZ7D4M5fXuTgAASAAVwAHFRwEZCSJBJIgEkWAxAWfdbtlVdwR/33tcjsy6HbIWqQ1Coujs/PJ/lQdAsf++r04CSEA5ASpQHgAkSAXaK/AA+SCINXvoR1oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/languageflags/ru.png
// module id = 182
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22